
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.481","height":"23.303","viewBox":"0 0 12.481 23.303"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 147418","d":"M11.663 13.108l.647-4.217H8.264V6.154a2.109 2.109 0 012.378-2.278h1.84V.285A22.436 22.436 0 009.215 0C5.882 0 3.704 2.02 3.704 5.676V8.89h-3.7v4.217h3.7V23.3h4.56V13.1z","fill":"#245389"}})])
          )
        }
      }
    